import React, { useContext } from "react";
import { useNavigate } from "react-router";
import { SliderContext } from "./App";
import { AppContext } from "../window";
import { useTranslation } from "../i18n";
import ChatIcon from "@mui/icons-material/Chat";
import FavoriteIcon from "@mui/icons-material/Favorite";
import AppAvatar from "../libs/AppAvatar";

export interface SlideModalProps {
  onNextUser: () => void;
}

export const SlideModal: React.FC<SlideModalProps> = ({ onNextUser }) => {
  const { t } = useTranslation();
  const { texts } = useContext(AppContext);
  const { user, legacyMode } = useContext(SliderContext);
  const navigate = useNavigate();

  if (!user) {
    return null;
  }

  const handleChatClick = () => {
    if (legacyMode) {
      window.location.href = `/chat/conversation/v2?uid=${user.id}`;
    } else {
      navigate(`/inbox/${user.id}`);
    }
  };

  const handleContinueMatching = () => {
    onNextUser();
  };

  return (
    <div className="match">
      <div className="d-flex justify-content-center mb-3">
          <AppAvatar src={user.displayPicture.thumb} circle pulsingBorder pulsingBorderColor="danger" size="xxl" />
      </div>
      <p className="text-center w-100 mb-3">{texts.itsAMatch?.replace('%nickname%', user.nickname)}</p>
      <div className="d-grid gap-3">
        <button onClick={handleChatClick} className="btn btn-danger btn-lg shadow-sm d-flex align-items-center justify-content-center gap-2">
          <ChatIcon fontSize="large" /> 
          <span>{t('slider.chat_now')}</span>
        </button>
        <button onClick={handleContinueMatching} className="btn btn-primary btn-lg shadow-sm d-flex align-items-center justify-content-center gap-2">
          <FavoriteIcon fontSize="large" /> 
          <span>{t('slider.continue_matching')}</span>
        </button>
      </div>
    </div>
  );
};

